import React, { useState } from 'react';
import { IChatMessage } from '../../../../../libs/models/ChatMessage';
import { ImageOverlay } from '../Shared/ImageOverlay';

interface ChatItemImageContentProps {
    isMe: boolean;
    message: IChatMessage;
}

export const ChatItemImageContent: React.FC<ChatItemImageContentProps> = ({ message }) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const imageSrc = `data:image/webp;base64,${message.content}`;

    const handleImageClick = () => {
        setIsOverlayOpen(true);
    };

    const handleCloseOverlay = () => {
        setIsOverlayOpen(false);
    };

    return (
        <>
            <div className="w-[60%] relative group">
                <img 
                    src={imageSrc} 
                    alt="generated image" 
                    className="cursor-pointer hover:opacity-90 transition-opacity rounded-lg shadow-md"
                    onClick={handleImageClick}
                />
                
                {/* Hover overlay to indicate clickability */}
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-lg flex items-center justify-center cursor-pointer" onClick={handleImageClick}>
                    <div className="bg-white/90 dark:bg-gray-800/90 px-3 py-1 rounded-full text-sm font-medium">
                        Click to enlarge
                    </div>
                </div>
            </div>
            
            <ImageOverlay
                open={isOverlayOpen}
                onClose={handleCloseOverlay}
                imageSrc={imageSrc}
                altText="Generated image"
            />
        </>
    );
};
